module.exports = fox._r("images/slides/urban/slide_2_4.jpg", __webpack_public_path__ + "images/slides/urban/slide_2_4.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/slides/urban/slide_2_4.jpg
// module id = 57
// module chunks = 2